import User from './User';
import Article from './Article';
import Model from './Model';

export default class OrderItem implements Model{
    private user:User;
    private article:Article;
    private size:string;
    private createdAt:Date;
    private id:number;

    /**
     * Getter $createdAt
     * @return {Date}
     */
	public get $createdAt(): Date {
		return this.createdAt;
	}

    /**
     * Getter $payed
     * @return {boolean}
     */
	public get $payed(): boolean {
		return this.payed;
	}



    /**
     * Setter $payed
     * @param {boolean} value
     */
	public set $payed(value: boolean) {
		this.payed = value;
	}
    private payed:boolean;


	constructor($id: number,$user: User, $article: Article, $size:string, $creationTimestamp:number = 0, $payed:boolean = false) {
        this.id = $id;
        this.user = $user;
		this.article = $article;
        this.size = $size;
        this.createdAt = new Date($creationTimestamp*1000);
        this.payed = $payed;
	}


    /**
     * Getter $user
     * @return {User}
     */
	public get $user(): User {
		return this.user;
	}

    /**
     * Getter $article
     * @return {Article}
     */
	public get $article(): Article {
		return this.article;
	}

    /**
     * Getter $size
     * @return {string}
     */
	public get $size(): string {
		return this.size;
	}

    /**
     * Setter $user
     * @param {User} value
     */
	public set $user(value: User) {
		this.user = value;
	}

    /**
     * Setter $article
     * @param {Article} value
     */
	public set $article(value: Article) {
		this.article = value;
	}

    /**
     * Setter $size
     * @param {string} value
     */
	public set $size(value: string) {
		this.size = value;
    }


    /**
     * Getter $id
     * @return {number}
     */
	public get $id(): number {
		return this.id;
	}

    /**
     * Setter $id
     * @param {number} value
     */
	public set $id(value: number) {
		this.id = value;
	}

    
    public getPrice() {
        for (const priceItem of this.article.$prices) {
            if (priceItem.$name === this.size) {
                return priceItem.$price
            }
        }
        throw "invalid size";
        
    }

    public isStarorder() {

        console.log({name: this.$article.$name, price: this.getPrice()})
        return this.$article.$isStarorder && this.$size === 'L' && this.getPrice() > 6
    }

    public getSize() {
        return this.size;
    }



}